const ERROR_QUEUE = [];
const MAX_QUEUE = 50;
const FLUSH_INTERVAL = 30000;
const ERRORS_PER_FLUSH = 10;
let flushTimer = null;

function formatError(error, context = {}) {
  return {
    message: error?.message || String(error),
    stack: error?.stack?.split('\n').slice(0, 5).join('\n') || '',
    url: window.location.href,
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString(),
    ...context,
  };
}

export function reportError(error, context = {}) {
  if (!error) return;
  const formatted = formatError(error, context);
  if (ERROR_QUEUE.length >= MAX_QUEUE) ERROR_QUEUE.shift();
  ERROR_QUEUE.push(formatted);
}

function flushErrors() {
  if (ERROR_QUEUE.length === 0) return;
  const batch = ERROR_QUEUE.splice(0, ERRORS_PER_FLUSH);
  const endpoint = process.env.REACT_APP_ERROR_REPORTING_API;
  if (endpoint) {
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ errors: batch }),
      keepalive: true,
    }).catch(() => {});
  }
}

export function initErrorReporting() {
  window.addEventListener('error', (event) => {
    reportError(event.error || new Error(event.message), {
      source: 'window.onerror',
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    reportError(event.reason, { source: 'unhandledrejection' });
  });

  if (flushTimer) clearInterval(flushTimer);
  flushTimer = setInterval(flushErrors, FLUSH_INTERVAL);

  window.addEventListener('beforeunload', flushErrors);
}

export function getErrorQueue() {
  return [...ERROR_QUEUE];
}

export function clearErrorQueue() {
  ERROR_QUEUE.length = 0;
}
